import React from 'react';
import { Hero } from '../components/home/Hero';
import { ShopPreview } from '../components/home/ShopPreview';
import { Steps } from '../components/home/Steps';
import { Values } from '../components/home/Values';
import { Transparency } from '../components/home/Transparency';
import { LabsPreview } from '../components/home/LabsPreview';
import { Testimonial } from '../components/home/Testimonial';
import { SectionHeading } from '../components/ui/SectionHeading';
import { FaqList } from '../components/ui/FaqList';
import { CtaBand } from '../components/ui/CtaBand';
import { faqs } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { useBrand } from '../contexts/BrandContext';
export function Home() {
  const {
    brand
  } = useBrand();
  useDocumentMeta({
    title: brand.copy.metaTitle,
    description: brand.copy.metaDescription,
    image: brand.images.hero
  });
  return <main data-id="element-391" data-mp="3ovub9vog9pkb">
      <Hero data-id="element-392" data-mp="3ovkjc2juh8bz" />
      <ShopPreview data-id="element-393" data-mp="3ovavakid1b8x" />
      <Steps data-id="element-394" data-mp="3oyq9ll47mg9a" />
      <Values data-id="element-395" data-mp="30wrnkc0kxpdf" />
      <Transparency data-id="element-396" data-mp="30xb9e3tcoxwq" />
      <LabsPreview data-id="element-397" data-mp="30vqeue71deyv" />
      <Testimonial data-id="element-398" data-mp="30w9nt5epkt0r" />

      <section className="bg-cream-light" data-id="element-399" data-mp="30ufb2edlc77r">
        <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-24" data-id="element-400" data-mp="2vxf503gqr4gn">
          <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-401" data-mp="2qybwua5gsi4g">
            <SectionHeading eyebrow="FAQ" title="The questions people actually ask." data-id="element-402" data-mp="2r0gbnn4wj1ji" />
            <FaqList items={faqs} data-id="element-403" data-mp="2mwqmavgekfxf" />
          </div>
        </div>
      </section>

      <CtaBand data-id="element-404" data-mp="2hyp4edupqmnj" />
    </main>;
}